export default "__VITE_ASSET__C9O2aHCu__"